<template>
  <div id="purchase-path">
    <app-header />
    <debug v-if="debugging" />
    <timer v-if="showTimer"/>

    <div class="back-and-progress" :class="{ 'back-and-progress--back-visible' : showBackButton }" v-if="showBackButton || showProgressBar">
      <back-button v-if="showBackButton"/>
      <progress-bar v-if="showProgressBar"/>
    </div>
    <global-error v-if="showError" class="global-error"/>
    <div class="pp-main-content-wrapper" v-show="!loading">
      <router-view/>
    </div>
    <div v-show="loading">
      <loading-animation />
    </div>
    <newsletter-block />
    <secondary-footer />
  </div>
</template>
<script>
import AppHeader from "@/components/layout/AppHeader";
import PrimaryFooter from "@/components/layout/PrimaryFooter";
import SecondaryFooter from "@/components/layout/SecondaryFooter";
import NewsletterBlock from "@/components/layout/NewsletterBlock";
import ProgressBar from "@/components/layout/ProgressBar";
import LoadingAnimation from "@/components/generic/LoadingAnimation";
import Debug from "@/components/Debug";
import Timer from "@/components/layout/Timer";
import GlobalError from "@/components/generic/GlobalError";
import BackButton from "@/components/generic/BackButton";
import { mapState, mapGetters, mapActions } from "vuex"
import moment from "moment"

export default {
  name: "app",
  components: {
    AppHeader,
    PrimaryFooter,
    SecondaryFooter,
    ProgressBar,
    LoadingAnimation,
    Debug,
    Timer,
    GlobalError,
    BackButton,
    NewsletterBlock
  },
  computed: {
    showTimer() {
      return this.$route.name != 'cart-confirmation'
    },
    showError() {
      return this.error.length > 0 && !this.loading
    },
    showBackButton() {
      let backButtonVisible = false; 
      
      switch(this.$route.name) {
        case "choose-seat-flow":
        case "delivery-details":
        case "payment":
        case "payment-failed":
        case "registration-details":
          backButtonVisible = true;
          break;
        default: 
          backButtonVisible = false
          break;
      }

      if(this.loading || this.stage == 'choose-date-time') {
        backButtonVisible = false;
      }

      return backButtonVisible
    },
    showProgressBar() {
      if (this.$route.name == null) {
        return false;
      }

      // Don't show on login screen
      if (this.$route.name == 'login') return false
      // Don't show the progress bar if it's an empty cart
      if(this.$route.name == 'shopping-cart' && this.cartIsEmpty) return false
      // If we're on the choose-date-time screen
      // AND we're *not* on the registration flow, hide the progress bar.
      if(!this.$route.name.includes('registration') && this.stage == 'choose-date-time') return false;
      if(this.loading) return false
      return true;
    },
    ...mapGetters(['cartIsEmpty']),
    ...mapState(['loading', 'debugging', 'stage', 'error', 'headerMenu', 'footerPrimaryMenuItem', 'footerSecondaryMenuItem'])
  },
  watch: {
    "$i18n.locale"() {
      let currentPathName = window.location.pathname.toString();
      let updatedPathName = currentPathName.split('/');
      let urlLocales = ['en', 'sc', 'tc'];
      
      if (urlLocales.includes(updatedPathName[1])) {
        updatedPathName[1] = this.$i18n.locale;
        updatedPathName = updatedPathName.join('/')
        window.history.replaceState("", document.title, updatedPathName);
      } else {
        updatedPathName.splice(1, 0, this.$i18n.locale)
        updatedPathName = updatedPathName.join('/')
        window.history.replaceState("", document.title, updatedPathName);
      }

      // Updating address bar without refresh: https://stackoverflow.com/questions/3338642/updating-address-bar-with-new-url-without-hash-or-reloading-the-page
      this.setAppLocaleCookie(this.$i18n.locale);
      this.getMainSite();
    }
  },
  methods: {
    setAppLocaleCookie(language) {
      let htmlLangAttribute = 'en'

      if(language == "sc") {
        htmlLangAttribute = "zh-hans";
      } else if(language == "tc") {
        htmlLangAttribute = "zh-hant";
      }

      // Set lang attribute in HTML element; this controls fonts
      document.querySelector('html').setAttribute("lang", htmlLangAttribute);
  
      this.$cookie.set('app-locale', language, { expires: '1Y' });
    },
    async checkLastUserVisit() {
      let previouslyOnSite = this.$cookie.get('lastNavigation');
      let vuexCookie = localStorage.getItem("vuex");
      let timeNow = new moment(new Date());

      if(previouslyOnSite) {
        let timeSinceLastVisit = new moment(previouslyOnSite);

        // This should probably be 30 minutes.. but giving it some leeway
        if(timeNow.diff(timeSinceLastVisit, 'hours') > 1 && vuexCookie) {
          localStorage.removeItem('vuex');
          this.$cookie.set('lastNavigation', timeNow);
          window.reload();
        } else {
          // Always set lastNavigation time
          this.$cookie.set('lastNavigation', timeNow);
        }
      } else {
        this.$cookie.set('lastNavigation', timeNow);
      }
    },
    ...mapActions(['getMainSite', 'destroyCartInstance'])
  },
  // Deciding locale must come before we try and render components as they are dependent on it.
  async beforeMount() {
    this.setAppLocaleCookie(this.$i18n.locale);
  },
  async mounted() {
    await this.getMainSite();
  },
  async created() {
    await this.checkLastUserVisit();
  }
};
</script>
